import React, { useContext, useState, useEffect } from 'react'
import styled, { css } from 'styled-components'

import { Fonts, Icon } from 'components/base-ui'
import { AppContext } from 'contexts/AppProvider'
import { LanguageEnum } from 'enums'
import useSetUserPreferences from 'services/hooks/useSetUserPreferences'
import { onClick } from 'helpers/fastClick'

export enum SwitchLangThemeTypeEnum {
  grey = 'grey',
}

interface SwitchLangProps {
  theme?: SwitchLangThemeTypeEnum
}

const SwitchLang: React.FC<SwitchLangProps> = ({ theme }) => {
  const { lang, accessToken } = useContext(AppContext)
  const [isOpenMenuDropdown, setIsOpenMenuDropdown] = useState<boolean>(false)

  useEffect(() => {
    const handleDetectClickWindowToCloseMenuDropdown = () => setIsOpenMenuDropdown(false)
    document.body.addEventListener('click', handleDetectClickWindowToCloseMenuDropdown)

    return () => {
      document.body.removeEventListener('click', handleDetectClickWindowToCloseMenuDropdown)
    }
  }, [])

  const [updateLang] = useSetUserPreferences(accessToken)

  return (
    <SwitchWrapper>
      <BtnSwitch
        color={theme}
        $isOpenMenuDropdown={isOpenMenuDropdown}
        {...onClick(
          () => {
            setIsOpenMenuDropdown(!isOpenMenuDropdown)
          },
          {
            stopPropagation: true,
          }
        )}
      >
        <Fonts.SmallTitleMedium style={{ whiteSpace: 'nowrap' }}>
          {lang === LanguageEnum.th ? 'TH' : 'EN'}
        </Fonts.SmallTitleMedium>
        <IconCaretTop name="caret-right" $isOpenState={isOpenMenuDropdown} />
      </BtnSwitch>

      <MenuDropdown $isShow={isOpenMenuDropdown} onClick={(e) => e.stopPropagation()}>
        <Menus>
          <Menu $isActive={lang === LanguageEnum.th} onClick={() => handleSelectlang(LanguageEnum.th)}>
            <Fonts.SmallTitleMedium style={{ whiteSpace: 'nowrap' }}>TH - ภาษาไทย</Fonts.SmallTitleMedium>
          </Menu>
          <Menu $isActive={lang === LanguageEnum.en} onClick={() => handleSelectlang(LanguageEnum.en)}>
            <Fonts.SmallTitleMedium style={{ whiteSpace: 'nowrap' }}>EN - English</Fonts.SmallTitleMedium>
          </Menu>
        </Menus>
      </MenuDropdown>
    </SwitchWrapper>
  )

  async function handleSelectlang(selectLang: LanguageEnum) {
    if (selectLang === lang) {
      setIsOpenMenuDropdown(false)
    } else {
      try {
        const result = await updateLang({
          variables: {
            language: selectLang,
          },
        })

        if (result && result.data && result.data.setUserPreferences) {
          window.location.reload()
        }
      } catch (err) {}
      setIsOpenMenuDropdown(false)
    }
  }
}

export default SwitchLang
const BorderStyled = css`
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.hatoBrand.primary.active};
`

const SwitchWrapper = styled.div`
  position: relative;
`

const BtnSwitch = styled.div<{ color?: SwitchLangThemeTypeEnum; $isOpenMenuDropdown: boolean }>`
  display: flex;
  ${BorderStyled}
  padding: 4px 10px;
  color: ${({ theme }) => theme.colors.hatoBrand.primary.active};

  ${({ color }) =>
    color === SwitchLangThemeTypeEnum.grey &&
    `
    padding: 2px 8px;
  `}

  ${({ theme, color, $isOpenMenuDropdown }) =>
    color === SwitchLangThemeTypeEnum.grey &&
    !$isOpenMenuDropdown &&
    `
    color: ${theme.colors.darkGrey};
    border: 1px solid ${theme.colors.baseGrey};
  `}
`

const IconCaretTop = styled(Icon)<{ $isOpenState: boolean }>`
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize.sm};
  transform: ${({ $isOpenState }) => ($isOpenState ? 'rotate(-90deg)' : 'rotate(90deg)')};
  transition: 0.3s;
`

const MenuDropdown = styled.div<{ $isShow: boolean }>`
  ${BorderStyled}
  padding: 5px 0;
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: ${({ theme }) => theme.spacing['3XS']};
  background-color: ${({ theme }) => theme.colors.element.white};
  visibility: hidden;
  opacity: 0;
  transform: translate(0, -5px);
  transition: 0.3s;
  z-index: 101;

  ${({ $isShow }) =>
    $isShow
      ? css`
          visibility: visible;
          transform: translate(0, 0);
          opacity: 1;
        `
      : ''}
`

const Menus = styled.div``

const Menu = styled.div<{ $isActive: boolean }>`
  padding: 5px 20px;
  color: ${({ theme, $isActive }) => ($isActive ? theme.colors.hatoBrand.primary.active : theme.colors.base)};
`
